import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import DataTable from "react-data-table-component";
import ProgressComponent from "../../components/general/ProgressComponent";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  getRecords,
  isSuccess,
  catchAsync,
  filterColumns,
  filterRowsByProperty,
  toastErrorMessages,
} from "../../helper/helper";
import {
  BASE_URL,
  GET_STAFF_WORKLOADS_URL,
} from "../../env";
import moment from "moment/moment";
import editBlock from "../../assets/images/icons/editBlock.svg";
import password_eye_icon_circle from "../../assets/images/icons/password_eye_icon_circle.svg";
import PermissionWrapper from "../../permission_advance/PermissionWrapper";
import { hasAnyPermissions } from "../../permission_advance/PermissionColumn";
import ViewStaffWorkLoad from "./ViewStaffWorkLoad";
import AddCarriedOver from "./AddCarriedOver";

function StaffWorkLoads() {
  const [isLoading, setIsLoading] = useState(true);
  const [userData, setUserData] = useState([]);
  const [isToastStaffWorkLoad, setIsToastStaffWorkLoad] = useState(false);

  const apiQuery = {
    sortproperty: "createdAt",
    sortorder: -1,
    offset: 0,
    query: {
      critarion: { active: true, isCurrentWrkLd: true, },
      staffMemberFields: "staffName",
      usersFields: "name profile_picture_url",
      addedby: "_id email name",
      lastModifiedBy: "_id email name",
    },
  };

  
  const processFetchRecords = (method, data) => {
    if (data?.status !== isSuccess) {
      setIsToastStaffWorkLoad(true);
      toastErrorMessages(toast?.error, data?.message, "", 1000, 1000);
    } else if (method === "get" && data?.status === isSuccess) {
      const userData = data?.data?.staffWorkLoads || [];
      setUserData(userData);
      setIsLoading(false);
    } 
  };

  const fetchAllRecords = catchAsync(async () => {
    try {
      const response = await getRecords(GET_STAFF_WORKLOADS_URL, apiQuery);
      
      processFetchRecords("get", response);
    } catch (error) {
      console.error("Error fetching staff workloads:", error);
    }
  });


  useEffect(() => {
    fetchAllRecords();
  }, []);

  const columns = [
    {
      name: "#",
      selector: (row, index) => <span>{index + 1}</span>,
      width: "5%",
      center: true,
    },
    {
      name: "Staff Name",
      selector: (row) => {
        return (
          <span className="usersNameInfo">
            <span className="userImage">
              <img
                src={`${BASE_URL}${row?.staffMember?.user?.profile_picture_url}`}
                alt={row?.staffMember?.name}
              />
            </span>
            <span className="userInfo">
              <span className="nameBlock">{row?.staffMember?.user?.name}</span>
            </span>
          </span>
        );
      },

    },
    {
      name: "Start Date",
      selector: (row) => {
        return <span>{moment(row?.startDate).format("DD/MM/YYYY")}</span>;
      },
      center: true,
      width: "12%",
    },
    {
      name: "End Date",
      selector: (row) => {
        return <span>{moment(row?.endDate).format("DD/MM/YYYY")}</span>;
      },
      center: true,
      width: "12%",
    },
    {
      name: "Allowed Hours",
      selector: (row) => {
        return <span>{row?.holidayAlwnNoOfHours === 0 ? row?.holidayAlwnNoOfHours : (row?.holidayAlwnNoOfHours.toFixed(2))}</span>;
      },
      center: true,
      width: "10%",
    },
    {
      name: "Availed Hours",
      selector: (row) => {
        return <span>{row?.holidayHoursAvailed === 0 ? row?.holidayHoursAvailed : (row?.holidayHoursAvailed.toFixed(2))}</span>;
      },
      center: true,
      width: "10%",
    },
    {
      name: "Remain Hours",
      selector: (row) => {
        return <span>{row?.holidayHoursRemaining === 0 ? row?.holidayHoursRemaining : (row?.holidayHoursRemaining.toFixed(2))}</span>;
      },
      center: true,
      width: "10%",
    },
    {
      name: "Carried Hours",
      selector: (row) => {
        return <span>{row?.carriedOverHours}</span>;
      },
      center: true,
      width: "10%",
    },
    ...(hasAnyPermissions(["create", "update", "delete"], "Staff")
      ? [
        {
          name: "Action",
          selector: (row) => {
            return (
              <div className="actionColumns">
                <PermissionWrapper title="Staff" action="view">
                  <span className="edit view"
                    onClick={() => subModalViewWorkLoad(row)}
                  >
                    <img src={password_eye_icon_circle} alt="View" title="View" />
                  </span>
                </PermissionWrapper>
                <PermissionWrapper title="Staff" action="update">
                  <span
                    className="edit"
                    onClick={() => subModalUpdateWorkLoad(row)}
                  >
                    <img src={editBlock} alt="Edit" title="Edit" />
                  </span>
                </PermissionWrapper>
              </div>
            );
          },
          width: "10%",
          center: true,
        },
      ]
      : []),

  ];


  const filteredColumns = filterColumns(columns, (column) => column !== null);
  const filteredRows = filterRowsByProperty(
    userData,
    (row) => row?.staffMember?.user?.name
  );




  // View Modal Popup
  const [showViewWorkLoad, setShowViewWorkLoad] = useState(false);
  const [viewStaffMemberData, setViewStaffMemberData] = useState("");
  const subModalViewWorkLoad = (staffData) => {
    setViewStaffMemberData(staffData)
    setShowViewWorkLoad(!showViewWorkLoad);
  };

  // Update Modal Popup
  const [showUpdateWorkLoad, setShowUpdateWorkLoad] = useState(false);
  const subModalUpdateWorkLoad = (staffData) => {
    setViewStaffMemberData(staffData)
    setShowUpdateWorkLoad(!showUpdateWorkLoad);
    fetchAllRecords();
  };


  return (
    <>
      <div className="mainContent rowClickUnset absenceLeave">
        <div className="dataTableWrapper">
          <DataTable
            className="maxWidthTable minWidthTable"
            columns={filteredColumns}
            data={filteredRows}
            pagination
            paginationRowsPerPageOptions={[10, 25, 50, 100]}
            paginationPerPage={10}
            fixedHeader
            fixedHeaderScrollHeight="470px"
            highlightOnHover
            responsive={true}
            progressPending={isLoading}
            progressComponent={<ProgressComponent />}
          />
        </div>
      </div>

      {/* View Staff Work Load */}
      <Modal
        show={showViewWorkLoad}
        onHide={subModalViewWorkLoad}
        className="ftcModalPopup medicineInventoryStock"
        size={"xl"}
      >
        <Modal.Header closeButton>
          <Modal.Title>View Staff WorkLoads</Modal.Title>
        </Modal.Header>
        <Modal.Body className="rosterPopup">
          <ViewStaffWorkLoad
            viewStaffMemberData={viewStaffMemberData}
          />
        </Modal.Body>
      </Modal>

      {/* Update Staff Work Load */}
      <Modal
        show={showUpdateWorkLoad}
        onHide={subModalUpdateWorkLoad}
        className="ftcModalPopup medicineInventoryStock"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Carried Hour</Modal.Title>
        </Modal.Header>
        <Modal.Body className="rosterPopup">
          <AddCarriedOver
            subModalUpdateWorkLoad={subModalUpdateWorkLoad}
            viewStaffMemberData={viewStaffMemberData}
          />
        </Modal.Body>
      </Modal>

      {isToastStaffWorkLoad && <ToastContainer />}
    </>
  );
}

export default StaffWorkLoads;
